import { programTypesConfigContext } from "../../contexts/programTypes/programTypesConfig.context";

const getMandatoryServiceQuestionsProgramTypes = () =>
  programTypesConfigContext.config
    .filter((programType) => programType.hasMandatoryQuestions)
    .map((programType) => programType.name);

export default getMandatoryServiceQuestionsProgramTypes;
